import { render, staticRenderFns } from "./coring-sidewell-desc.vue?vue&type=template&id=09c261be&scoped=true"
import script from "./coring-sidewell-desc.vue?vue&type=script&lang=js"
export * from "./coring-sidewell-desc.vue?vue&type=script&lang=js"
import style0 from "./coring-sidewell-desc.vue?vue&type=style&index=0&id=09c261be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c261be",
  null
  
)

export default component.exports